import { HeadCell } from '../../../UI/Table/TableHeader'
import { TypePosition } from '../../types/TypePosition'

interface TypePositionHeadCell extends TypePosition {
  actions: string
}

export const headCells: HeadCell<TypePositionHeadCell>[] = [
  {
    id: 'typePositionId',
    numeric: false,
    disablePadding: true,
    label: 'ID',
    sortable: false,
    visible: true
  },
  {
    id: 'typePositionCode',
    numeric: false,
    disablePadding: true,
    label: 'CÓDIGO',
    sortable: false,
    visible: true
  },
  {
    id: 'typePositionDescription',
    numeric: false,
    disablePadding: false,
    label: 'DESCRIPCIÓN',
    sortable: false,
    visible: true
  },
  {
    id: 'considerInventory',
    numeric: false,
    disablePadding: false,
    label: 'INFORMA INVENTARIO',
    sortable: false,
    visible: true
  },
  {
    id: 'requireZone',
    numeric: false,
    disablePadding: false,
    label: 'REQUIERE ZONA',
    sortable: false,
    visible: true
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: true,
    label: 'ACCIONES',
    sortable: false,
    visible: true
  }
]
